import React from "react";
import "./client-logo.css";

const logos = [
  "/assets/images/client-logos/aws-logo.png",
  "/assets/images/client-logos/sap-logo.png",
  "/assets/images/client-logos/epicsai-logo.png",
  "/assets/images/client-logos/Microsoft-logo.png",
  "/assets/images/client-logos/koncept-house-logo.png",
  "/assets/images/client-logos/Intellectt_logo.webp",
  "/assets/images/client-logos/deckers_logo.webp",
  "/assets/images/client-logos/mec-logo.png",
  "/assets/images/client-logos/axiss-logo.png",
  "/assets/images/client-logos/proleads-logo.png",
];

const ClientLogos = () => {
  return (
    <div className="client-logos-section">
      <div className="logos-container">
        <div className="logos-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt={`Client ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLogos;
